import { useEffect, useRef, RefObject } from 'react';

interface UseIntersectionObserverOptions {
  threshold?: number[];
  rootMargin?: string;
}

const useIntersectionObserver = <T extends HTMLElement>(
  callback: (isIntersecting: boolean) => void,
  options: UseIntersectionObserverOptions = {}
): RefObject<T> => {
  const elementRef = useRef<T>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        callback(!entry.isIntersecting);
      },
      {
        threshold: options.threshold || [1],
        rootMargin: options.rootMargin || '0px 0px 0px 0px'
      }
    );

    const currentRef = elementRef.current;
    if (currentRef) {
      observer.observe(currentRef);
    }

    return () => {
      if (currentRef) {
        observer.unobserve(currentRef);
      }
    };
  }, [callback, options.threshold, options.rootMargin]);

  return elementRef;
};

export default useIntersectionObserver;
